<template>
  <div>
    <b-spinner v-if="loading" />
    <div v-else>
      <b-form-group :label="$t('partner.notes.label')" label-for="notes-input">
        <b-form-textarea
          id="notes-input"
          v-model="notes"
          :placeholder="$t('partner.notes.placeholder')"
          :disabled="saving"
          rows="3"
        />
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          :disabled="saving || !hasChanges"
          @click="cancelChanges"
        >
          {{ $t('partner.notes.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="saving || !hasChanges"
          @click="saveNotes"
        >
          <b-spinner small v-if="saving" class="mr-1" />
          {{ $t('partner.notes.save') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapGetters } from 'vuex';
import { UPDATE_PARTNER_NOTES } from '@/store/partners.module';

export default {
  name: 'PartnerNotes',
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notes: '',
      originalNotes: '',
      loading: false,
      saving: false,
    };
  },
  computed: {
    ...mapGetters(['getPartnerByAccountId']),
    hasChanges() {
      return this.notes !== this.originalNotes;
    },
  },
  watch: {
    partner: {
      immediate: true,
      handler() {
        this.loadNotes();
      },
    },
  },
  methods: {
    ...mapMutations([UPDATE_PARTNER_NOTES]),

    loadNotes() {
      if (!this.partner?.account?.id) {
        return;
      }

      this.loading = true;

      // First check if we have updated notes in the store
      const storePartner = this.getPartnerByAccountId(this.partner.account.id);
      const notesFromStore = storePartner?.account?.notes;

      // Use store notes if available, otherwise use partner prop notes
      this.notes =
        notesFromStore !== undefined
          ? notesFromStore
          : this.partner.account.notes || '';
      this.originalNotes = this.notes;
      this.loading = false;
    },

    async saveNotes() {
      if (!this.partner?.account?.id) {
        this.$bvToast.toast(this.$t('partner.notes.error.no-account'), {
          title: this.$t('partner.notes.error.title'),
          variant: 'danger',
        });
        return;
      }

      this.saving = true;

      try {
        await axios.patch(`/data-api/account/${this.partner.account.id}`, {
          notes: this.notes,
        });

        // Update the store with the new notes
        this[UPDATE_PARTNER_NOTES]({
          accountId: this.partner.account.id,
          notes: this.notes,
        });

        this.originalNotes = this.notes;
        this.$bvToast.toast(this.$t('partner.notes.success'), {
          title: this.$t('partner.notes.success-title'),
          variant: 'success',
        });
      } catch (error) {
        console.error('Error saving notes:', error);
        this.$bvToast.toast(this.$t('partner.notes.error.save'), {
          title: this.$t('partner.notes.error.title'),
          variant: 'danger',
        });
      } finally {
        this.saving = false;
      }
    },

    cancelChanges() {
      this.notes = this.originalNotes;
    },
  },
};
</script>
